import React from 'react';
import { Form, Select } from 'antd';

const { Option } = Select;

const CarSelect = ({ value, allcars, cars, onChange, placeholder = "Выберите автомобиль" }) => {


    const handleChange = (selectedOption) => {
        // selectedOption будет объектом { value: id, label: name }
        onChange(selectedOption.value);
    };

    const selectedCar = allcars.find(car => car.id === value);
    const displayValue = selectedCar ? { value: selectedCar.id, label: selectedCar.name } : undefined;

    return (
        <Form.Item label="Автомобиль">
            <Select
                value={displayValue}
                onChange={handleChange}
                placeholder={placeholder}
                labelInValue
                showSearch
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {cars.map(car => (
                    <Option key={car.id} value={car.id}>
                        {car.name}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default CarSelect;